import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {contactData.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {contactData.methods.map((m) => (
              <div
                key={m.label}
                className="flex items-center gap-4 p-4 rounded-lg text-left"
                style={{ backgroundColor: 'oklch(var(--background-100))' }}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: 'oklch(var(--primary-100))' }}>
                  <i className={`${m.icon} text-lg`} style={{ color: 'oklch(var(--primary-500))' }}></i>
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-foreground-500">{m.label}</p>
                  <p className="text-sm font-medium text-foreground-800 truncate">{m.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}